import {Pipe, PipeTransform} from '@angular/core';

const PREFIX = 'VIEWS.USER_BOARD.SUBSCRIPTION_AND_PLANS.FEATURE_KEYS.';

@Pipe({
	name: 'featureKeyLabel',
	standalone: true,
	pure: true,
})
export class FeatureKeyLabelPipe implements PipeTransform {
	transform(key: string | null | undefined): string {
		if (!key) return '';
		return PREFIX + key.toUpperCase();
	}
}
